import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './auth/login/login.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { RegisterComponent } from './auth/register/register.component';
import { VerifyComponent } from './auth/verify/verify.component';
import { VerifiedComponent } from './auth/verified/verified.component';
import { ReverifyComponent } from './auth/reverify/reverify.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { StatusComponent } from './auth/status/status.component';
import { AuthenticateComponent as GoogleAuthenticate } from 'src/app/auth/google/authenticate/authenticate.component';
import { GoogleCallbackComponent as GoogleCallback } from 'src/app/auth/google/callback/callback.component';
import { AuthenticateComponent as FacebookAuthenticate } from 'src/app/auth/facebook/authenticate/authenticate.component';
import { CallbackComponent as FacebookCallback } from 'src/app/auth/facebook/callback/callback.component';
import { AuthenticateComponent as TwitterAuthenticate } from 'src/app/auth/twitter/authenticate/authenticate.component';
import { CallbackComponent as TwitterCallback } from 'src/app/auth/twitter/callback/callback.component';
import { AuthenticateComponent as LinkedinAuthenticate } from 'src/app/auth/linkedin/authenticate/authenticate.component';
import { CallbackComponent as LinkedinCallback } from 'src/app/auth/linkedin/callback/callback.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/auth/status'},
  { path: 'auth/status', component: StatusComponent},
  { path: 'auth/employee/login', component: LoginComponent},
  { path: 'auth/logout', component: LogoutComponent},
  { path: 'auth/employee/register', component: RegisterComponent },
  { path: 'verify/:purpose/:email_verify', component: VerifyComponent },
  { path: 'auth/reset/password/:email_code/:user_id', component: ResetPasswordComponent },
  { path: 'auth/google/url', component: GoogleAuthenticate },
  { path: 'auth/google/callback', component: GoogleCallback },
  { path: 'auth/facebook/authenticate', component: FacebookAuthenticate },
  { path: 'auth/facebook/callback', component: FacebookCallback },
  { path: 'auth/twitter/authenticate', component: TwitterAuthenticate },
  { path: 'auth/twitter/callback', component: TwitterCallback },
  { path: 'auth/linkedin/authenticate', component: LinkedinAuthenticate },
  { path: 'auth/linkedin/callback', component: LinkedinCallback },
  { path: 'reverify', component: ReverifyComponent },
  { path: 'verified', component: VerifiedComponent },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
